import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/conspretratamiento";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllConspretratamientoByTax(params.tratamientoId);
}

export function ConspretratamientoList(props) {
  const [conspretratamientoList, setConspretratamiento] = useState([]);
  let { tratamientoId } = useParams();

  useEffect(() => {
    API.getAllConspretratamientoByTax(props.id).then(setConspretratamiento).catch(console.log);
  }, [props.id]);

  return (

    <>
      {conspretratamientoList?.length ? (
        <ul className="entrenamiento cpt-list">
          {conspretratamientoList
            .sort((a, b) => {
              // Convertir las fechas a objetos de fecha para comparar
              const dateA = new Date(a?.meta?.metaFecha);
              const dateB = new Date(b?.meta?.metaFecha);
              
              // Ordenar de manera descendente (más reciente primero)
              return dateB - dateA;
            })
            .map((conspretratamiento) => (
              <li key={conspretratamiento.id}>
                <NavLink className="capitalize" to={`${props.id}/antecedentes/consulta-pre-tratamiento/${conspretratamiento.id}`}>
                  {`${FormatDate(conspretratamiento.meta?.metaFecha)} - ${conspretratamiento.meta?.conspretTipo}`}
                </NavLink>
              </li>
            ))}
        </ul>
          ) : (
            <></>
          )}
    </>
  );
}



export function ConspretratamientoListContent() {
  let { tratamientoId } = useParams();
  console.log(tratamientoId);
  return (
    <>
      <div id="content">
        <h1>Consulta Pre-Tratamiento</h1>
      </div>
      <div id="actions">
        {<Link className="button is-link" to={`new`}>Nuevo</Link>}
      </div>
    </>
  );
}